jQuery(document).ready(function($) {
  const mapContainer = $('#world-map');

  if (!$.fn.vectorMap || typeof window.officeLocationsData === 'undefined') {
    console.error('Map or data missing.');
    return;
  }

  mapContainer.vectorMap({
    map: 'world_en',
    backgroundColor: '#ffffff',
    showZoom: false,
    regionStyle: {
      initial: {
        fill: '#e0eef6',
        stroke: '#e0eef6',
        'stroke-width': 0,
        'stroke-opacity': 1,
      },
      hover: {
        fill: '#e0eef6' // prevent hover color
      },
      selected: {
        fill: '#e0eef6'
      }
    },
    pins: window.officePins || {},
    pinMode: 'content',
    onRegionClick: function(event, code) {
      const idx = window.officeLocationsData.findIndex(loc => loc.location_country_code.toLowerCase() === code.toLowerCase());
      if (idx !== -1 && $('.office-slider').hasClass('slick-initialized')) {
        $('.office-slider').slick('slickGoTo', idx);
        highlightPin(idx);
      }
    },
    onLabelShow: function(event, label, code) {
      const loc = window.officeLocationsData.find(loc => loc.location_country_code.toLowerCase() === code.toLowerCase());
      if (loc) label.html(loc.location_title + '<br>' + loc.location_address);
    }
  });

  const mapObject = mapContainer.vectorMap('get', 'mapObject');

  function highlightPin(index) {
    $('.office-slide').removeClass('active');
    $(`.office-slide[data-index="${index}"]`).addClass('active');

    const loc = window.officeLocationsData[index];
    if (!loc) return;

    // Clear all pins' active state
    $('.jqvmap-pin').removeClass('active');

    // Add active class to the correct pin
    $(`.jqvmap-pin[for="${loc.location_country_code.toLowerCase()}"]`).addClass('active');
  }

  // ✅ Corrected: bind click on outer .jqvmap-pin element
  $(document).on('click', '.jqvmap-pin', function () {
    const code = $(this).attr('for');
    const idx = window.officeLocationsData.findIndex(loc => loc.location_country_code.toLowerCase() === code.toLowerCase());
    if (idx !== -1 && $('.office-slider').hasClass('slick-initialized')) {
      $('.office-slider').slick('slickGoTo', idx);
      highlightPin(idx);
    }
  });

  // Slide changes → highlight correct pin
  $('.office-slider').on('beforeChange', function(e, slick, cur, next) {
    highlightPin(next);
  });

  // Hover over slide → highlight pin
  $('.office-slide').on('mouseenter', function() {
    highlightPin($(this).data('index'));
  });

  // Initial highlight
  highlightPin(0);
});
